"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifyProjectForPrintableModifications = void 0;
const Product_1 = require("../../../models/Product");
const modifyProjectForPrintableModifications = (project, art, numInteriorPrintables) => {
  const isSpreadBook = (0, Product_1.isSpreadBooksCategory)(project.product.hammerCategory);
  project.product.pageCount = isSpreadBook ? numInteriorPrintables * 2 : numInteriorPrintables;
  const optionName = (0, Product_1.getOptionThatControlsPageCount)(project.product.options);
  if (optionName && art.attributes[optionName]) {
    const pageOptions = art.attributes[optionName].options.map(o => Number(o.value));
    pageOptions.sort((a, b) => a - b);
    const numInteriorPages = isSpreadBook ? numInteriorPrintables * 2 : numInteriorPrintables;
    let pageOption = pageOptions[0];
    pageOptions.forEach(po => {
      if (numInteriorPages >= po) {
        pageOption = po;
      }
    });
    project.product.options[optionName] = String(pageOption);
  }
  return project;
};
exports.modifyProjectForPrintableModifications = modifyProjectForPrintableModifications;